import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { StatusPill } from "@/components/StatusPill";

const getBannerContent = (status, audience) => {
  if (audience === "public") {
    if (status === "success") {
      return {
        title: "Aktywacja dostępu zakończona",
        message: "Twój dostęp do kolejnego etapu został uruchomiony. W razie potrzeby wróć tutaj po kolejne aktualizacje.",
      };
    }

    if (status === "failed" || status === "missing_access_token" || status === "missing_user_record") {
      return {
        title: "Aktywacja jest w toku",
        message: "Twoje zgłoszenie zostało zaakceptowane. Jeśli dalszy etap nie pojawi się od razu, zespół wznowi aktywację po swojej stronie.",
      };
    }

    return {
      title: "Kolejny etap procesu",
      message: "Po aktualizacji statusu uruchamiamy dalsze kroki po naszej stronie. Wróć do panelu, aby sprawdzić nowe informacje.",
    };
  }

  if (status === "success") {
    return {
      title: "Aktywacja dostępu zakończona",
      message: "Dostęp został aktywowany poprawnie. W razie potrzeby możesz ponowić akcję z poziomu panelu wewnętrznego.",
    };
  }

  if (status === "failed" || status === "missing_access_token" || status === "missing_user_record") {
    return {
      title: "Wymagana ponowna aktywacja",
      message: "Aktywacja dostępu nie została dokończona. Użyj przycisku ponowienia w panelu szczegółów zgłoszenia.",
    };
  }

  return {
    title: "Aktywacja oczekuje",
    message: "Dalszy etap dostępu uruchomi się po zapisaniu decyzji lub po ponowieniu operacji.",
  };
};

export const AutomationBanner = ({ provisioning, compact = false, audience = "internal" }) => {
  const status = provisioning?.status || "awaiting_bot_setup";
  const fallbackMessage = provisioning?.message;
  const content = getBannerContent(status, audience);

  return (
    <Alert
      className="border-primary/20 bg-primary/8"
      data-testid="automation-status-panel"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="space-y-1">
          <AlertTitle className="text-sm font-semibold text-foreground">
            {content.title}
          </AlertTitle>
          <AlertDescription className="text-sm text-muted-foreground">
            {audience === "internal" && fallbackMessage ? fallbackMessage : content.message}
          </AlertDescription>
        </div>
        <StatusPill status={status} className={compact ? "self-start" : "self-start sm:self-auto"} />
      </div>
    </Alert>
  );
};
